import { useContext } from 'react';
import createNamedContext from 'utils/createNamedContext';

interface WorkBenchContextValue {
  activeKey?: string;
}

export const WorkBenchContext = createNamedContext<WorkBenchContextValue | null>(
  'WorkBenchContext',
  null,
);

export const useWorkBenchContext = () => {
  const value = useContext(WorkBenchContext);
  if (!value) {
    throw new Error('no WorkBenchContext value');
  }
  return value;
};
